import { Form, Row } from 'react-bootstrap'
import { Button } from 'react-bootstrap'
import { Col } from 'react-bootstrap'
import { BsFillChatRightTextFill } from 'react-icons/bs'

export const NonSelectedChat = () => {

    return (
        <div className="border border-secondary rounded pt-4 h-100 " >

            <div className="mb-3 p-3 d-flex justify-content-center align-items-center" style={{ minHeight: "65vh", maxHeight: "65vh", overflowY: "auto", display: "flex", flexDirection: "column" }}>

                <div className="text-center text-primary">
                    <BsFillChatRightTextFill size={100} />
                    <div className='mt-3'>
                        <span>Selecciona un chat</span>
                    </div>
                </div>

            </div>
            <hr />
            <Row className="mt-3  py-3">
                <Col xs={9}>
                    <Form.Control
                        type="text"
                        disabled
                        placeholder="Selecciona un chat..."
                        value={''}
                        className="text-light py-2"
                    />
                </Col>
                <Col xs={3}>
                    <Button disabled variant="primary" onClick={() => { }} className="w-100">
                        Enviar
                    </Button>
                </Col>
            </Row>
        </div>
    )
}
